import React, {Component} from 'react';
import {getIconSrc} from "../../../../../../utils/Utils";
import './IconButton.css';

class IconButton extends Component {
    render() {
        let buttonStyles = {
            backgroundImage: `url(${getIconSrc(this.props.icon.image) + '?' + this.props.icon.versionNum})`,
            backgroundColor: this.props.icon.color
        };
        return (
            <li onMouseDown={this.props.iconOnClick} onClick={this.props.iconOnClick} className="IconButton">
                <div style={buttonStyles} className={"icon " + this.props.className}>

                </div>
                <div className="text">
                    {this.props.icon.text}
                </div>
            </li>
        );
    }
}

export default IconButton;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/DrawerContainer/components/IconButton/index.js